import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@components/ui/alert-dialog';
import { Button } from '@components/ui/button';

type UnsavedChangesModalProps = {
  isOpen: boolean;
  isSaving?: boolean;
  onCancel: () => void;
  onDiscard: () => void;
  onSaveAndContinue: () => void;
};

export const UnsavedChangesModal: React.FC<UnsavedChangesModalProps> = (props) => {
  const { isOpen, isSaving = false, onCancel, onDiscard, onSaveAndContinue } = props;

  return (
    <AlertDialog
      onOpenChange={(open) => {
        if (!open) {
          onCancel();
        }
      }}
      open={isOpen}
    >
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>You have unsaved changes</AlertDialogTitle>
          <AlertDialogDescription>
            You have unsaved changes. Would you like to save them before navigating away?
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter className="w-full flex-1 sm:justify-start">
          <AlertDialogCancel
            disabled={isSaving}
            onClick={onCancel}
          >
            Cancel
          </AlertDialogCancel>
          <Button
            className="ml-auto"
            disabled={isSaving}
            onClick={onDiscard}
            variant="destructive"
          >
            Discard
          </Button>
          <AlertDialogAction asChild>
            <Button
              loading={isSaving}
              onClick={onSaveAndContinue}
            >
              Save and Continue
            </Button>
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
